var exports = {
  "form": "x24da60e8--bf761e--form",
  "desktop": "x24da60e8--bf761e--desktop",
  "inputs": "x24da60e8--bf761e--inputs",
  "phone": "x24da60e8--bf761e--phone",
  "tablet": "x24da60e8--bf761e--tablet",
  "form-group": "x24da60e8--bf761e--form-group",
  "inputs-group": "x24da60e8--bf761e--inputs-group",
  "checkbox": "x24da60e8--bf761e--checkbox",
  "submit": "x24da60e8--bf761e--submit",
  "textarea": "x24da60e8--bf761e--textarea",
  "file": "x24da60e8--bf761e--file",
  "drag-and-drop": "x24da60e8--bf761e--drag-and-drop",
  "action-area": "x24da60e8--bf761e--action-area",
  "action-wrapper-when-sticky": "x24da60e8--bf761e--action-wrapper-when-sticky",
  "full-width": "x24da60e8--bf761e--full-width",
};

module.exports = exports;
